// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component___4E1G","slider":"style_slider__iAsrt","slide":"style_slide__dONgW"};